import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'

import { it, enGB, Locale } from 'date-fns/locale'
import { useRouter } from 'next/router'

export const dateLocales: Record<string, Locale> = {
  it,
  en: enGB,
}

export const supportedLanguages = [
  { text: '🇺🇸 EN', value: 'en' },
  { text: '🇮🇹 IT', value: 'it' },
]

export function LanguageSwitcher() {
  const router = useRouter()

  const changeUserLanguage = (locale: string) => {
    const { pathname, asPath, query } = router
    router.push({ pathname, query }, asPath, { locale })
  }

  return (
    <div>
      <Select
        value={router.locale}
        onValueChange={(value) => changeUserLanguage(value)}
      >
        <SelectTrigger className="border-none shadow-none focus:ring-0 focus:ring-ring hover:bg-accent">
          <SelectValue placeholder="" />
        </SelectTrigger>
        <SelectContent>
          {supportedLanguages.map(({ text, value }) => (
            <SelectItem value={value} key={value}>
              {text}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  )
}
